// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');

$export($export.S, 'Math', { scale: require('./_math-scale') });



//////////////////
// WEBPACK FOOTER
// ../~/core-js/modules/es7.math.scale.js
// module id = 1289
// module chunks = 0